import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';
import { formatLocalDateAnswer, parseLocalDateAnswer } from 'src/app/core-module/models/Utils/local-date-answer';

@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrl: './date.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateComponent {
  public selectedDate: Date | null = null;
  public selectedTime: Date | null = null;
  public selectedCalendarDate: Date | null = null;

  @Input() width: string = '1/5';
  @Input() includeTime:boolean = false;
  @Input() currentQuestion: CAQuestion;
  @Output() currentQuestionChange = new EventEmitter<CAQuestion>();


  ngOnChanges() {
    this.validateIncomingDate(this.currentQuestion?.AnswerText);
  }
  validateIncomingDate(value: Date | string | null | undefined) {
    const incomingDate = parseLocalDateAnswer(value);
    this.selectedDate = incomingDate ? new Date(incomingDate.getTime()) : null;
    this.selectedTime = incomingDate ? new Date(incomingDate.getTime()) : null;
    this.selectedCalendarDate = incomingDate ? new Date(incomingDate.getTime()) : null;
  }

  updateCurrentDate() {
    if (!this.selectedCalendarDate || (this.includeTime && !this.selectedTime)) {
      this.selectedDate = null;
      this.currentQuestion.AnswerText = '';
      this.currentQuestion.IsAnswered = this.currentQuestion.NASelected;
      this.currentQuestionChange.emit(this.currentQuestion);
      return;
    }

    const time = this.includeTime ? this.selectedTime! : this.selectedCalendarDate;
    this.selectedDate = new Date(
      this.selectedCalendarDate.getFullYear(),
      this.selectedCalendarDate.getMonth(),
      this.selectedCalendarDate.getDate(),
      this.includeTime ? time.getHours() : 0,
      this.includeTime ? time.getMinutes() : 0,
      this.includeTime ? time.getSeconds() : 0
    );
    this.currentQuestion.AnswerText = formatLocalDateAnswer(this.selectedDate, this.includeTime);
    this.currentQuestion.IsAnswered = true;
    this.currentQuestionChange.emit(this.currentQuestion);
  }
  updateNA(){
    this.currentQuestion.NASelected = !this.currentQuestion.NASelected;
    this.validateAnswered();
  }
  validateAnswered(){
    this.currentQuestion.IsAnswered = this.currentQuestion.NASelected || !!this.currentQuestion.AnswerText;
    this.currentQuestionChange.emit(this.currentQuestion);
  }
}
